import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function Clear(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="-1 0 24 24" {...props}>
      <path d="M20 6v12a2 2 0 0 1-2 2H7l-6-8 6-8h11a2 2 0 0 1 2 2Zm-2.001-.001h-10l-4.5 6 4.5 6h10v-12ZM9.12 7.71 7.71 9.12 10.59 12l-2.88 2.88 1.41 1.41L12 13.41l2.88 2.88 1.41-1.41L13.41 12l2.88-2.88-1.41-1.41L12 10.59" />
    </SvgIcon>
  );
}
